import {ListBase, ListProps, Record, useListContext} from "react-admin";
import React from "react";
import {Button, Card, Table} from "antd";
import {Link} from "react-router-dom";
import SkeletonTable, {SkeletonTableColumnsType} from "../../Common/SkeletonTable";
import { EditOutlined,} from "@ant-design/icons";
import {formatDateAndTime} from "@src/helpers/utils";
import DeleteButton from "@src/components/Common/DeleteButton";
import type { TableColumnsType as ColumnsType } from "antd";


const TruncateText = ( text: string, length: number ) => {
    const shouldTruncate = text.length > length;
    const displayText = shouldTruncate ? text.slice(0, length) + '...' : text;
    return <span>{displayText}</span>;
};


const MessageListView = () => {
    const { ids, data, loaded, total, perPage, setPage, page, refetch } = useListContext();

    const columns: ColumnsType<Record> = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: '5%',
        },
        {
            title: "Message",
            dataIndex: "description",
            key: "description",
            width: '30%',
            align: 'left',
            render: (text: any) => TruncateText(text, 30)
        },
        {
            title: 'Services',
            key: 'service',
            render: (record: any) => {
                const scopes = record.scopes;
                if (!scopes || scopes.length === 0) {
                    return <>All Services</>;
                }

                const scopeNames = scopes.map((item: any) => item.scope.name).join(', ');
                return <>{scopeNames}</>;
            }
        },
        {
            title: 'Expiry Date',
            dataIndex: 'expiry_date',
            key: 'expiry_date',
            render: (text: string) => text?formatDateAndTime(text):<>-</>,
        },
        {
            align: 'right',
            fixed: 'right',
            render: (text: any, record: any) =>
                <div>
                    <Button style={{ marginRight: '5px'}}>
                        <Link to={`/serviceowner_messages/${record.id}/edit`}><EditOutlined />Edit</Link>
                    </Button>
                    <DeleteButton title={"message"} resource={"serviceowner_messages"} record={record} refetch={refetch} style={{ marginRight: '5px'}} />
                </div>
        },
    ]


    const tableData: Record[] = []
    ids.forEach(id => tableData.push(data[id]))
    return (
        <Card
            extra={<Link to="/serviceowner_messages/create"><Button type='primary'>Create New Message</Button></Link>}
        >
        <SkeletonTable loading={!loaded} columns={columns as SkeletonTableColumnsType[]}>
            <Table
                rowKey='id'
                tableLayout="fixed"
                columns={columns}
                pagination={{ total: total, pageSize: perPage, current: page, onChange: page => setPage(page), className: "pagination-padding" }}
                dataSource={tableData}

            />
        </SkeletonTable>
        </Card>
    )
}

const MessageList = (props: ListProps) => {
    return (
        <ListBase sort={{ field: 'id', order: 'DESC' }} perPage={25} {...props}>
            <MessageListView />
        </ListBase>
    )
}

export default MessageList;
